import {
  Box,
  Flex,
  Text,
  TextArea,
  typography,
  useColorMode,
  useToast,
  spacing,
  SecondaryButton,
  color,
} from 'deepstash-ui';

import React, { useState } from 'react';
import { TOAST_TIME } from 'utils/constants';

interface OwnProps {
  handleReport: (reportType: string) => Promise<void>;
}

export const ReportModalText: React.FC<OwnProps> = ({ handleReport }) => {
  const { colorMode } = useColorMode();
  const toast = useToast();
  const [localValue, setLocalValue] = useState('');

  const onSendReportPress = () => {
    if (localValue.trim() !== '') {
      handleReport(localValue);
    } else {
      toast({
        title: 'Invalid message!',
        description: `Message cannot be empty.`,
        status: 'error',
        duration: TOAST_TIME,
        isClosable: true,
      });
    }
  };

  return (
    <>
      <Flex
        fontSize="1.75rem"
        lineHeight="2.375rem"
        fontWeight="bold"
        color={color[colorMode].text}
        align="center"
        py={'unset'}
        justifyContent="center"
        pt="1rem"
      >
        <Text>Report</Text>
      </Flex>
      <Box px="0px" pb="10px" mt={spacing.S.rem}>
        <Text
          color={color[colorMode].textSecondary}
          {...typography.primaryTextFonts.medium.semiBold}
          my={spacing.XS.rem}
          mt={0}
        >
          Something else
        </Text>
        <TextArea
          placeholder="Tell us what's wrong with this..."
          textColor={color[colorMode].textSecondary}
          borderRadius={16}
          _focus={{
            border: `2px solid ${color.light.primary.default}`,
          }}
          backgroundColor={color[colorMode].top}
          color={color[colorMode].text}
          value={localValue}
          onChange={e => setLocalValue(e.target.value)}
          minHeight={128}
          w="100%"
          py="0.75rem"
          px="1rem"
          boxSizing="border-box"
          {...typography.primaryTextFonts.medium.regular}
        />
      </Box>
      <Box m={'unset'} p={'unset'}>
        <SecondaryButton
          colorMode={colorMode}
          title={'Send report'}
          onClick={onSendReportPress}
          w={'100%'}
          {...typography.primaryTextFonts.medium.bold}
          borderRadius={16}
          fontSize={spacing.toRem(18)}
        />
      </Box>
    </>
  );
};
